module.exports = require("deep-extend");


//////////////////
// WEBPACK FOOTER
// external "deep-extend"
// module id = 178
// module chunks = 0